import React from 'react'
import "./PackageDetail.css";
import { Link } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import WhyTrust from '../layout/WhyTrust';

export default function BookingForm() {
  return (
    <>
    <Header/>
      
    <div className="test_bredcum_sec">
        <div className="container-fluid">
            <div className="test_bredcum">
                <Link to="/">Home</Link>
                <span>&gt;</span>
                <span className='name_p'>Booking Form</span>
            </div> 
        </div> 
    </div>
   <div className="booking_form_main">
      <div className="container-fluid">
        <div className="inner_booking_form">
            <div className="row">
                <div className="col-lg-7">
                    <div className="booking_box booking_first_sec">
                        <h2>Who are you booking For?</h2>
                        <div className="radio_btn_booking_form">
                            <input type="radio" id="self" name="booking" defaultChecked hidden />
                            <label htmlFor="self" className="booking_card">
                            <div className="radio_circle"></div>
                            <div className="icon-bookform"><PersonIcon/></div>
                            <h3>Booking For Self</h3>
                            </label>

                            <input type="radio" id="other" name="booking" hidden />
                            <label htmlFor="other" className="booking_card">
                            <div className="radio_circle"></div>
                            <div className="icon-bookform"><GroupsIcon/></div>
                            <h3>Booking for Others</h3>
                            </label>
                        </div>
                    </div>

                    <div className="booking_box patient_info_form">
                        <h3>Patient Information</h3>
                        <div className="form_patient_info">
                            <form>
                                <div className="row"> 
                                    <div className="col-12 mb-3"> 
                                      <input type="text"  className="form-control" placeholder="Patient Name" />
                                    </div> 

                                    <div className="col-md-6 mb-3"> 
                                        <input type="tel" className="form-control" placeholder="Phone Number" />
                                    </div>
 
                                    <div className="col-md-6 mb-3"> 
                                        <input  type="email"  className="form-control"   placeholder="Email" />
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <select className="form-select">
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Age"
                                            min="0"
                                        />
                                    </div>

                                </div>
                                </form>
                        </div>
                    </div>

                    <div className="booking_box sample_address">
                        <h3>Sample Collection Address</h3>
                        <div className="samele_add_radio_btn">
                            <label className="address_box">
                                <input type="radio" name="address" defaultChecked />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Work Address</h4>
                                    <p>15 Corner, Sector 10 Shopping Center Vijay Path
                                        Crossing, Madhyam Marg, Mansarovar,
                                        Jaipur, Rajasthan 302020
                                    </p>
                                </div>
                            </label>

                            <label className="address_box">
                                <input type="radio" name="address" />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Home Address</h4>
                                    <p> 45 Shyam Nagar Sodala, Jaipur,
                                        Rajasthan 302020
                                    </p>
                                </div>
                            </label>

                            <label className="address_box">
                                <input type="radio" name="address" />
                                <span className="radio_circle"></span>
                                <div className="address_content">
                                    <h4>Other Address</h4>
                                    <p> 80 Ram 200 Feet Road,
                                        Jaipur, Rajasthan 302020
                                    </p>
                                </div>
                            </label>
                        </div>
                        <div className="add_more_btn">
                            <a href="#"> <div><AddOutlinedIcon/> Add New Address</div></a>
                        </div>
                    </div>

                    <div className="booking_box calender_booking_form">
                        <h3>When Would you collect the sample?</h3>
                        <div className="inner_calender_sec">
                            <div className="date_cal_bookingform headins_time_sample-box">
                                <h4><CalendarMonthOutlinedIcon/> Select Date</h4>
                                <div className="select_date_bookingform">
                                    <input type="radio" name="date" id="d1" defaultChecked hidden />
                                    <label htmlFor="d1" className="date_box">
                                        <span>Mon</span>
                                        <h3>30</h3>
                                    </label>

                                    <input type="radio" name="date" id="d2" hidden />
                                    <label htmlFor="d2" className="date_box">
                                        <span>Tue</span>
                                        <h3>31</h3>
                                    </label>

                                    <input type="radio" name="date" id="d3" hidden />
                                    <label htmlFor="d3" className="date_box">
                                        <span>Wed</span>
                                        <h3>01</h3>
                                    </label>

                                    <input type="radio" name="date" id="d4" hidden />
                                    <label htmlFor="d4" className="date_box">
                                        <span>Thu</span>
                                        <h3>02</h3>
                                    </label>

                                    <input type="radio" name="date" id="d5" hidden />
                                    <label htmlFor="d5" className="date_box">
                                        <span>Fri</span>
                                        <h3>03</h3>
                                    </label>

                                    <input type="radio" name="date" id="d6" hidden />
                                    <label htmlFor="d6" className="date_box">
                                        <span>Fri</span>
                                        <h3>04</h3>
                                    </label>

                                    <input type="radio" name="date" id="d7" hidden />
                                    <label htmlFor="d7" className="date_box">
                                        <span>Fri</span>
                                        <h3>05</h3>
                                    </label>

                                    <div className="more_date">
                                        <CalendarMonthOutlinedIcon/>
                                        <p>More Dates</p>
                                    </div>
                                    </div>
                            </div>
                            
                            <div className="morning_time_booking headins_time_sample-box">
                                <h4><WbTwilightOutlinedIcon/> Select Time (Morning)</h4>
                                <div className="timeing_redio">

                                    <input type="radio" id="time1" name="time" defaultChecked />
                                    <label htmlFor="time1" className="time_box">
                                        <span></span>
                                        <p>10:00 to 11:00 Am</p>
                                    </label>

                                    <input type="radio" id="time2" name="time" />
                                    <label htmlFor="time2" className="time_box">
                                        <span></span>
                                        <p>11:00 to 12:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time3" name="time" />
                                    <label htmlFor="time3" className="time_box">
                                        <span></span>
                                        <p>12:00 to 01:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time4" name="time" />
                                    <label htmlFor="time4" className="time_box">
                                        <span></span>
                                        <p>01:00 to 02:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time5" name="time" />
                                    <label htmlFor="time5" className="time_box">
                                        <span></span>
                                        <p>02:00 to 03:00 Pm</p>
                                    </label>

                                </div>
                            </div>

                            <div className="headins_time_sample-box">
                                <h4><LightModeOutlinedIcon/> Select Time (Evening)</h4>
                                <div className="timeing_redio">

                                    <input type="radio" id="time6" name="time" defaultChecked />
                                    <label htmlFor="time1" className="time_box">
                                        <span></span>
                                        <p>10:00 to 11:00 Am</p>
                                    </label>

                                    <input type="radio" id="time7" name="time" />
                                    <label htmlFor="time2" className="time_box">
                                        <span></span>
                                        <p>11:00 to 12:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time8" name="time" />
                                    <label htmlFor="time3" className="time_box">
                                        <span></span>
                                        <p>12:00 to 01:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time9" name="time" />
                                    <label htmlFor="time4" className="time_box">
                                        <span></span>
                                        <p>01:00 to 02:00 Pm</p>
                                    </label>

                                    <input type="radio" id="time10" name="time" />
                                    <label htmlFor="time5" className="time_box">
                                        <span></span>
                                        <p>02:00 to 03:00 Pm</p>
                                    </label>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="col-lg-5">
                    <div className="for_sticky_section">
                        <div className="summary_sec booking_box">
                            <h3>Summary</h3>
                            <div className="price_booking">
                                <div className="name_price_booking">
                                    <h4>Package Fees</h4>
                                    <h5>₹999</h5>
                                </div>
                                <div className="name_price_booking">
                                    <h4>Plateform Fees</h4>
                                    <h5>₹0</h5>
                                </div>
                                <div className="name_price_booking">
                                    <h4>GST (18%)</h4>
                                    <h5>₹152.43</h5>
                                </div> 
                            </div>
                            <div className="total_price_booking ">
                                <h4>Total Payable</h4>
                                <h5>₹ 1,151.643</h5>
                            </div>
                        </div>

                        <div className="policy-btn-box booking_box summary_sec">
                            <div className="icon_content_pb">
                                <VerifiedUserOutlinedIcon/>
                                <div>
                                    <h5>Your payment is Safe & Secure</h5>
                                    <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                                </div>
                            </div>
                            <div className='police_btn_booking'><a href="#">View Policy <KeyboardArrowRightOutlinedIcon/></a></div> 
                        </div>

                        <div className="total_payble booking_box">
                            <div className="text_payble">
                                <p>Total Payble</p>
                                <h5>₹ 1,151.64/-</h5>
                                <p>(Inclusive of all taxes)</p>
                            </div>
                            <div className="book_now_payble">
                                <Link to="/checkout">
                                    Book Now <EastOutlinedIcon/>
                                </Link>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
      </div>

      <WhyTrust/>
   </div>


    <Footer/>
    </>
  )
}
